import React, { useState, useEffect } from "react";

import TextAreaField from "./textarea-field";
import AnswerField from "./answer-field";
import CreateNewAnswer from "./create-new-answer";
import OtherAnswer from "./other-answer";

import "./answer-fields.scss";

const AnswerFields = (props) => {
	const {
		form: { getFieldValue, setFieldsValue, getFieldDecorator },
		questionId,
	} = props;
	const otherOptionKey = `questions[${questionId}].haveOtherOption`;
	const answerKeysOptionKey = `questions[${questionId}].answerKeys`;

	const answers = getFieldValue(answerKeysOptionKey)
		?.split(",")
		.map(Number) || [0];

	const [biggestId, setBiggestId] = useState(0);
	useEffect(() => {
		setBiggestId((biggestId) =>
			Math.max(
				biggestId,
				answers.reduce((acc, answerKey) => {
					if (acc < answerKey) {
						return answerKey;
					} else {
						return acc;
					}
				}, 0)
			)
		);
	}, [answers.length]);

	const haveOtherOption = getFieldValue(otherOptionKey);
	const onDelete = (delAnswerId) => {
		setFieldsValue({
			[answerKeysOptionKey]: answers
				.filter((answerId) => answerId !== delAnswerId)
				.join(","),
		});
	};
	const answerType = getFieldValue(`questions[${questionId}].answerType`);
	if (answerType === "text") {
		return <TextAreaField />;
	}
	return (
		<>
			{getFieldDecorator(answerKeysOptionKey, {
				initialValue: "0",
			})(<input style={{ display: "none" }} />)}
			{getFieldDecorator(otherOptionKey, {
				initialValue: false,
			})(<input style={{ display: "none" }} />)}
			{answers.map((answerId) => {
				return (
					<AnswerField
						{...props}
						download
						answerId={answerId}
						onDelete={onDelete}
						key={answerId}
					/>
				);
			})}
			{haveOtherOption && (
				<OtherAnswer
					{...props}
					onDeleteOther={() =>
						setFieldsValue({
							[otherOptionKey]: false,
						})
					}
				/>
			)}
			<CreateNewAnswer
				{...props}
				onAdd={() => {
					if (answers.length === 0) {
						setFieldsValue({
							[answerKeysOptionKey]: "0",
						});
					} else {
						setFieldsValue({
							[answerKeysOptionKey]: [...answers, biggestId + 1].join(","),
						});
					}
				}}
				onAddOther={() => {
					setFieldsValue({
						[otherOptionKey]: true,
					});
				}}
				haveOtherOption={haveOtherOption}
			/>
		</>
	);
};

export default AnswerFields;
